/**
 * Pure helpers for building LP requirements from DAG + packing lists.
 * No InstantDB dependency — safe to use in tests and workers.
 */

/** DAG node row (index, kind; eventId for event nodes). */
export interface DagNodeRow {
    index: number;
    kind: 'source' | 'event' | 'dest';
    eventId?: string | null;
}

/**
 * Build requirementsByItemType from DAG nodes and packing list data.
 * Node i: if kind is 'event', requirement = packing list quantity for that event and item type; else 0.
 */
export function buildRequirementsFromPackingLists(
    nodes: DagNodeRow[],
    packingListsByEvent: Map<string, Array<{ itemTypeId: string; quantity: number }>>
): Record<string, number[]> {
    const requirementsByItemType: Record<string, number[]> = {};
    const itemTypeIds = new Set<string>();
    for (const items of Array.from(packingListsByEvent.values())) {
        for (const item of items) {
            itemTypeIds.add(item.itemTypeId);
        }
    }
    for (const itemTypeId of Array.from(itemTypeIds)) {
        const R = nodes.map(n => {
            if (n.kind !== 'event' || !n.eventId) return 0;
            const items = packingListsByEvent.get(n.eventId) ?? [];
            const row = items.find(i => i.itemTypeId === itemTypeId);
            return row?.quantity ?? 0;
        });
        const hasReq = R.some(r => r > 0);
        if (hasReq) requirementsByItemType[itemTypeId] = R;
    }
    return requirementsByItemType;
}
